import {
  ContractDraft,
  ContractOrigin,
  EnterMargins,
  RenovateContractDraft,
  RenovateContractFormPymes,
  RenovateContractPymes,
  RenovateContractSave
} from '../models/renovate-contract-pymes.model';

export function mapperContractFather(response: ContractOrigin, idContract: string, isUserSpanish: boolean): RenovateContractPymes {
  return {
    idContractOrigin: idContract,
    campaign: {
      cups: response.datosAnalisisCampana.cups,
      cif: response.datosAnalisisCampana.cif,
      estimateConsuption: response.datosAnalisisCampana.consumoEstimado,
      geographicZone: response.datosAnalisisCampana.zonaGeograficaCUPS,
      campaign: response.datosAnalisisCampana.codigoCampana,
      level: response.datosAnalisisCampana.nombreNivel,
      campaignLabel: response.datosAnalisisCampana.nombreCampana,
      levelLabel: response.datosAnalisisCampana.nombreNivel,
      campaignBase: null,
      marginIndicator: '1',
      isMultibanco: response.datosAnalisisCampana?.isMultibanco,
      calculateMargins: {
        marginTP: {
          p1: null,
          p2: null,
          p3: null,
          p4: null,
          p5: null,
          p6: null,
        },
        marginTE: {
          p1: null,
          p2: null,
          p3: null,
          p4: null,
          p5: null,
          p6: null,
        },
      },
      enterMargins: {
        marginTP: null,
        marginsTE: null,
      },
      unitsTE: null,
      unitsTP: null,
      consumptionEstimatedPeriod: response.datosInstalacion.consumoEstimadoPeriodo,
      potencyContractedPeriod: response.datosInstalacion.potenciaContratadaPeriodo,
    },
    socialReason: {
      name: response.datosRazonSocial.nombre,
      cif: response.datosRazonSocial.cif,
      cnae: response.datosRazonSocial.cnae,
      nameContact: response.datosRazonSocial.nombreContactoComercial,
      surnameContact: response.datosRazonSocial.apellidosContactoComercial,
      dniContact: response.datosRazonSocial.dniContactoComercial,
      emailContact: response.datosRazonSocial.mailContactoComercial,
      phoneContact: response.datosRazonSocial.telefonoContactoComercial,
      viaType: response.datosRazonSocial.nombreTipoViaDireccion,
      roadName: response.datosRazonSocial.nombreDireccion,
      number: response.datosRazonSocial.numeroDireccion,
      gate: response.datosRazonSocial.portalDireccion,
      stair: response.datosRazonSocial.escaleraDireccion,
      floor: response.datosRazonSocial.pisoDireccion,
      door: response.datosRazonSocial.puertaDireccion,
      postalCode: response.datosRazonSocial.codPostalDireccion,
      codeTown: response.datosRazonSocial.codigoPoblacionDireccion,
      town: response.datosRazonSocial.nombrePoblacionDireccion,
    },
    installation: {
      codeSocialReason: null,
      codeCampaign: null,
      name: response.datosInstalacion.nombre,
      cups: response.datosInstalacion.cups,
      fee: null,
      feeLabel: response.datosInstalacion.tarifa,
      viaType: response.datosInstalacion.nombreTipoViaDireccion,
      roadName: response.datosInstalacion.nombreDireccion,
      number: response.datosInstalacion.numeroDireccion,
      gate: response.datosInstalacion.portalDireccion,
      stair: response.datosInstalacion.escaleraDireccion,
      floor: response.datosInstalacion.pisoDireccion,
      door: response.datosInstalacion.puertaDireccion,
      postalCode: response.datosInstalacion.codPostalDireccion,
      town: response.datosInstalacion.nombrePoblacionDireccion,
      codeTown: response.datosInstalacion.codigoPoblacionDireccion,
      tensionId: response.datosInstalacion.idTension,
      cycleId: response.datosInstalacion.idCiclo,
      periodId: response.datosInstalacion.idPeriodo,
      tension: response.datosInstalacion.tension,
      cycle: response.datosInstalacion.ciclo,
      period: response.datosInstalacion.periodo
    },
    contract: {
      codContract: response.datosContrato.codContrato,
      viaType: response.datosContrato.tipoVia,
      roadName: response.datosContrato.nombreVia,
      number: response.datosContrato.numero_km,
      gate: response.datosContrato.portal,
      stair: response.datosContrato.escalera,
      floor: response.datosContrato.piso,
      door: response.datosContrato.puerta,
      postalCode: response.datosContrato.cp,
      town: response.datosContrato.poblacion,
      townLabel: response.datosContrato.nombrePoblacion,
      nameSigner: response.datosContrato.nombreFirmanteCliente,
      surnameSigner: response.datosContrato.apellidosFirmanteCliente,
      dniSigner: response.datosContrato.dniFirmanteCliente,
      emailSigner: response.datosContrato.emailFirmanteCliente,
      phoneSigner: response.datosContrato.movilFirmanteCliente,
      iban: null,
      entity: null,
      office: null,
      dc: null,
      account: null,
      renovateIban: response.datosContrato.iban,
      renovateEntity: response.datosContrato.entidad,
      renovateOffice: response.datosContrato.sucursal,
      renovateDc: response.datosContrato.dc,
      renovateAccount: response.datosContrato.cuenta,
    }
  };
}

export function mapperGetDraft(response: ContractDraft, idDraft: number): RenovateContractPymes {
  return {
    idContractOrigin: response.renovacionContrato,
    campaign: {
      approved: response.aprobado,
      cups: response.infoAnalisis.cups,
      cif: response.infoAnalisis.cif,
      estimateConsuption: response.infoAnalisis.consumoEstimado,
      geographicZone: response.infoAnalisis.zonaGeograficaCUPS,
      campaign: response.infoAnalisis.codigoCampana,
      level: response.infoAnalisis.nombreNivel,
      campaignLabel: response.infoAnalisis.nombreCampana,
      levelLabel: response.infoAnalisis.nombreNivel,
      campaignBase: response.infoAnalisis.campanaBase,
      marginIndicator: response.infoAnalisis.indicadorMargen ? response.infoAnalisis.indicadorMargen.toString() : null,
      unitsTE: response.infoAnalisis.unitsTE,
      unitsTP: response.infoAnalisis.unitsTP,
      isMultibanco: response.infoContrato?.isMultibanco,
      calculateMargins: {
        marginTP: {
          p1: parseMarginBack(response.infoAnalisis.calculateMargins.marginTP.p1),
          p2: parseMarginBack(response.infoAnalisis.calculateMargins.marginTP.p2),
          p3: parseMarginBack(response.infoAnalisis.calculateMargins.marginTP.p3),
          p4: parseMarginBack(response.infoAnalisis.calculateMargins.marginTP.p4),
          p5: parseMarginBack(response.infoAnalisis.calculateMargins.marginTP.p5),
          p6: parseMarginBack(response.infoAnalisis.calculateMargins.marginTP.p6)
        },
        marginTE: {
          p1: parseMarginBack(response.infoAnalisis.calculateMargins.marginTE.p1),
          p2: parseMarginBack(response.infoAnalisis.calculateMargins.marginTE.p2),
          p3: parseMarginBack(response.infoAnalisis.calculateMargins.marginTE.p3),
          p4: parseMarginBack(response.infoAnalisis.calculateMargins.marginTE.p4),
          p5: parseMarginBack(response.infoAnalisis.calculateMargins.marginTE.p5),
          p6: parseMarginBack(response.infoAnalisis.calculateMargins.marginTE.p6)
        }
      },
      enterMargins: parseEnterMargins(response),
      consumptionEstimatedPeriod: response.infoAnalisis.consumoEstimadoPeriodo,
      potencyContractedPeriod: response.infoAnalisis.potenciaContratadaPeriodo,
    },
    socialReason: {
      name: response.infoRazonSocial.nombre,
      cif: response.infoRazonSocial.cif,
      cnae: response.infoRazonSocial.cnae,
      nameContact: response.infoRazonSocial.nombreContactoComercial,
      surnameContact: response.infoRazonSocial.apellidosContactoComercial,
      dniContact: response.infoRazonSocial.dniContactoComercial,
      emailContact: response.infoRazonSocial.mailContactoComercial,
      phoneContact: response.infoRazonSocial.telefonoContactoComercial,
      viaType: response.infoRazonSocial.nombreTipoViaDireccion,
      roadName: response.infoRazonSocial.nombreDireccion,
      number: response.infoRazonSocial.numeroDireccion,
      gate: response.infoRazonSocial.portalDireccion,
      stair: response.infoRazonSocial.escaleraDireccion,
      floor: response.infoRazonSocial.pisoDireccion,
      door: response.infoRazonSocial.puertaDireccion,
      postalCode: response.infoRazonSocial.codPostalDireccion,
      town: response.infoRazonSocial.nombrePoblacionDireccion,
      codeTown: response.infoRazonSocial.codigoPoblacionDireccion
    },
    installation: {
      codeSocialReason: response.infoInstalacion.codigoRazonSocial,
      codeCampaign: response.infoInstalacion.codigoCampana,
      name: response.infoInstalacion.nombre,
      cups: response.infoInstalacion.cups,
      fee: response.infoAnalisis.tarifaSips,
      feeLabel: response.infoAnalisis.tarifaSips,
      viaType: response.infoInstalacion.nombreTipoViaDireccion,
      roadName: response.infoInstalacion.nombreDireccion,
      number: response.infoInstalacion.numeroDireccion,
      gate: response.infoInstalacion.portalDireccion,
      stair: response.infoInstalacion.escaleraDireccion,
      floor: response.infoInstalacion.pisoDireccion,
      door: response.infoInstalacion.puertaDireccion,
      postalCode: response.infoInstalacion.codPostalDireccion,
      town: response.infoInstalacion.nombrePoblacionDireccion,
      codeTown: response.infoInstalacion.codigoPoblacionDireccion,
      tensionId: response.infoAnalisis.idTension,
      cycleId: response.infoAnalisis.idCiclo,
      periodId: response.infoAnalisis.idPeriodo,
      tensionCUPS: response.infoAnalisis?.tensionCUPS,
      cycleCUPS: response.infoAnalisis?.cicloCUPS,
      periodCUPS: response.infoAnalisis?.periodoCUPS,
      nameTensionCUPS: response.infoAnalisis?.nombreTensionCUPS,
      nameCycleCUPS: response.infoAnalisis?.nombreCicloCUPS,
      namePeriodCUPS: response.infoAnalisis?.nombrePeriodoCUPS
    },
    contract: {
      codContract: response.renovacionContrato,
      idDraft,
      viaType: response.infoContrato.nombreTipoViaDireccion,
      roadName: response.infoContrato.nombreDireccion,
      number: response.infoContrato.numeroDireccion,
      gate: response.infoContrato.portalDireccion,
      stair: response.infoContrato.escaleraDireccion,
      floor: response.infoContrato.pisoDireccion,
      door: response.infoContrato.puertaDireccion,
      postalCode: response.infoContrato.codPostalDireccion,
      town: response.infoContrato.codigoPoblacionDireccion,
      townLabel: response.infoContrato.nombrePoblacionDireccion,
      nameSigner: response.infoContrato.nombreFirmante,
      surnameSigner: response.infoContrato.apellidosFirmante,
      dniSigner: response.infoContrato.dniFirmante,
      emailSigner: response.infoContrato.mailFirmante,
      phoneSigner: response.infoContrato.movilFirmante,
      iban: response.infoContrato.iban,
      entity: response.infoContrato.entidad,
      office: response.infoContrato.sucursal,
      dc: response.infoContrato.dc,
      account: response.infoContrato.cuenta,
      renovateIban: response.renovacionIban,
      renovateEntity: response.renovacionEntidad,
      renovateOffice: response.renovacionSucursal,
      renovateDc: response.renovacionDc,
      renovateAccount: response.renovacionCuenta,
    }
  };
}

export function mapperFormToDraft(dataContract: RenovateContractPymes, event: RenovateContractFormPymes): RenovateContractDraft {
  return {
    idBorrador: event.idDraft,
    numFormulario: 1,
    infoAnalisis: {
      cups: dataContract.campaign.cups,
      cif: dataContract.campaign.cif,
      consumoEstimado: dataContract.campaign.estimateConsuption,
      tarifaSips: event.fee,
      zonaGeograficaCUPS: dataContract.campaign.geographicZone,
      codigoCampana: event.campaign,
      nombreNivel: event.level,
      calculateMargins: {
        marginTP: {
          p1: parseMargin(event.calculateMargins?.marginTP?.p1),
          p2: parseMargin(event.calculateMargins?.marginTP?.p2),
          p3: parseMargin(event.calculateMargins?.marginTP?.p3),
          p4: parseMargin(event.calculateMargins?.marginTP?.p4),
          p5: parseMargin(event.calculateMargins?.marginTP?.p5),
          p6: parseMargin(event.calculateMargins?.marginTP?.p6)
        },
        marginTE: {
          p1: parseMargin(event.calculateMargins?.marginTE?.p1),
          p2: parseMargin(event.calculateMargins?.marginTE?.p2),
          p3: parseMargin(event.calculateMargins?.marginTE?.p3),
          p4: parseMargin(event.calculateMargins?.marginTE?.p4),
          p5: parseMargin(event.calculateMargins?.marginTE?.p5),
          p6: parseMargin(event.calculateMargins?.marginTE?.p6)
        }
      },
      enterMargins: {
        marginTP: parseMargin(event.enterMargins?.marginTP),
        marginsTE: {
          p1: parseMargin(event.enterMargins?.marginsTE?.p1),
          p2: parseMargin(event.enterMargins?.marginsTE?.p2),
          p3: parseMargin(event.enterMargins?.marginsTE?.p3),
          p4: parseMargin(event.enterMargins?.marginsTE?.p4),
          p5: parseMargin(event.enterMargins?.marginsTE?.p5),
          p6: parseMargin(event.enterMargins?.marginsTE?.p6)
        }
      },
      unitsTE: event.unitsTE,
      unitsTP: event.unitsTP,
      campanaBase: event.campaignBase,
      indicadorMargen: parseInt(event.marginIndicator, 10),
      consumoEstimadoPeriodo: dataContract.campaign.consumptionEstimatedPeriod,
      potenciaContratadaPeriodo: dataContract.campaign.potencyContractedPeriod,
      tensionCUPS: dataContract?.installation?.tensionCUPS ?? dataContract?.installation?.tension,
      cicloCUPS: dataContract?.installation?.cycleCUPS ?? dataContract?.installation?.cycle,
      periodoCUPS: dataContract?.installation?.periodCUPS ?? dataContract?.installation?.period
    },
    infoRazonSocial: {
      editable: false,
      nombre: dataContract.socialReason.name,
      cif: dataContract.socialReason.cif,
      cnae: dataContract.socialReason.cnae,
      nombreContactoComercial: event.name,
      apellidosContactoComercial: event.surname,
      dniContactoComercial: event.dni,
      telefonoContactoComercial: event.phone,
      mailContactoComercial: event.email,
      nombreTipoViaDireccion: dataContract.socialReason.viaType,
      nombreDireccion: dataContract.socialReason.roadName,
      numeroDireccion: dataContract.socialReason.number,
      portalDireccion: dataContract.socialReason.gate,
      escaleraDireccion: dataContract.socialReason.stair,
      pisoDireccion: dataContract.socialReason.floor,
      puertaDireccion: dataContract.socialReason.door,
      codPostalDireccion: dataContract.socialReason.postalCode,
      codigoPoblacionDireccion: dataContract.socialReason.codeTown,
      codigoProvinciaDireccion: dataContract.socialReason.province
    },
    infoInstalacion: {
      codigoRazonSocial: dataContract.installation.codeSocialReason,
      codigoCampana: event.campaign,
      nombre: dataContract.installation.name,
      cups: dataContract.installation.cups,
      nombreTipoViaDireccion: dataContract.installation.viaType,
      nombreDireccion: dataContract.installation.roadName,
      numeroDireccion: dataContract.installation.number,
      portalDireccion: dataContract.installation.gate,
      escaleraDireccion: dataContract.installation.stair,
      pisoDireccion: dataContract.installation.floor,
      puertaDireccion: dataContract.installation.door,
      codPostalDireccion: dataContract.installation.postalCode,
      codigoPoblacionDireccion: dataContract.installation.codeTown
    },
    infoContrato: {
      codidoInstalacion: null,
      codigoCampana: event.campaign,
      nombreNivel: event.level,
      nombreFirmante: event.nameSigner,
      apellidosFirmante: event.surnameSigner,
      dniFirmante: event.dniSigner,
      movilFirmante: event.phoneSigner,
      mailFirmante: event.emailSigner,
      nombreTipoViaDireccion: event.viaType,
      nombreDireccion: event.roadName,
      numeroDireccion: event.number,
      portalDireccion: event.gate,
      escaleraDireccion: event.stair,
      pisoDireccion: event.floor,
      puertaDireccion: event.door,
      codPostalDireccion: event.postalCode,
      codigoPoblacionDireccion: event.town,
      iban: event.iban,
      entidad: event.entity,
      sucursal: event.office,
      dc: event.dc,
      cuenta: event.account,
      isMultibanco: event.isMultibanco,
    }
  };
}

export function mapperFormToSave(dataContract: RenovateContractPymes, event: RenovateContractFormPymes): RenovateContractSave {
  return {
    codigoCRMContrato: dataContract.contract.codContract,
    idBorrador: event.idDraft,
    codigoCampana: event.campaign,
    isMultibanco: event.isMultibanco,
    nivel: event.level,
    tarifa: event.fee,
    nombreTipoViaDireccion: event.viaType,
    nombreDireccion: event.roadName,
    numeroDireccion: event.number,
    portalDireccion: event.gate,
    escaleraDireccion: event.stair,
    pisoDireccion: event.floor,
    puertaDireccion: event.door,
    codPostalDireccion: event.postalCode,
    codigoPoblacionDireccion: event.town,
    iban: event.iban || dataContract.contract.renovateIban,
    entidad: event.entity || dataContract.contract.renovateEntity,
    sucursal: event.office || dataContract.contract.renovateOffice,
    dc: event.dc || dataContract.contract.renovateDc,
    cuenta: event.account || dataContract.contract.renovateAccount,
    nombreFirmante: event.nameSigner,
    apellidosFirmante: event.surnameSigner,
    dniFirmante: event.dniSigner,
    movilFirmante: event.phoneSigner,
    mailFirmante: event.emailSigner,
    nombreContacto: event.name,
    apellidosContacto: event.surname,
    dniContacto: event.dni,
    movilContacto: event.phone,
    mailContacto: event.email,
    consumEstP1: dataContract.campaign.consumptionEstimatedPeriod[0]?.toString(),
    consumEstP2: dataContract.campaign.consumptionEstimatedPeriod[1]?.toString(),
    consumEstP3: dataContract.campaign.consumptionEstimatedPeriod[2]?.toString(),
    consumEstP4: dataContract.campaign.consumptionEstimatedPeriod[3]?.toString(),
    consumEstP5: dataContract.campaign.consumptionEstimatedPeriod[4]?.toString(),
    consumEstP6: dataContract.campaign.consumptionEstimatedPeriod[5]?.toString(),
    marginTP: parseMargin(event.enterMargins.marginTP),
    marginTE: {
      p1: parseMargin(event.enterMargins.marginsTE.p1),
      p2: parseMargin(event.enterMargins.marginsTE.p2),
      p3: parseMargin(event.enterMargins.marginsTE.p3),
      p4: parseMargin(event.enterMargins.marginsTE.p4),
      p5: parseMargin(event.enterMargins.marginsTE.p5),
      p6: parseMargin(event.enterMargins.marginsTE.p6)
    },
    unitsTP: event.unitsTP,
    unitsTE: event.unitsTE,
    indicadorMargen: parseInt(event.marginIndicator, 10),
    calculateMargins: {
      marginTP: {
        p1: parseMargin(event.calculateMargins.marginTP.p1),
        p2: parseMargin(event.calculateMargins.marginTP.p2),
        p3: parseMargin(event.calculateMargins.marginTP.p3),
        p4: parseMargin(event.calculateMargins.marginTP.p4),
        p5: parseMargin(event.calculateMargins.marginTP.p5),
        p6: parseMargin(event.calculateMargins.marginTP.p6)
      },
      marginTE: {
        p1: parseMargin(event.calculateMargins.marginTE.p1),
        p2: parseMargin(event.calculateMargins.marginTE.p2),
        p3: parseMargin(event.calculateMargins.marginTE.p3),
        p4: parseMargin(event.calculateMargins.marginTE.p4),
        p5: parseMargin(event.calculateMargins.marginTE.p5),
        p6: parseMargin(event.calculateMargins.marginTE.p6)
      }
    },
  };
}

export function updateData(dataContract: RenovateContractPymes, contractSave: RenovateContractSave): RenovateContractPymes {
  dataContract.campaign.campaign = contractSave.codigoCampana;
  dataContract.campaign.level = contractSave.nivel;
  dataContract.socialReason.name = contractSave.nombreContacto;
  dataContract.socialReason.surnameContact = contractSave.apellidosContacto;
  dataContract.socialReason.dniContact = contractSave.dniContacto;
  dataContract.socialReason.phoneContact = contractSave.movilContacto;
  dataContract.socialReason.emailContact = contractSave.mailContacto;
  dataContract.installation.fee = contractSave.tarifa;
  dataContract.contract.idDraft = contractSave.idBorrador;
  dataContract.contract.viaType = contractSave.nombreTipoViaDireccion;
  dataContract.contract.roadName = contractSave.nombreDireccion;
  dataContract.contract.number = contractSave.numeroDireccion;
  dataContract.contract.gate = contractSave.portalDireccion;
  dataContract.contract.stair = contractSave.escaleraDireccion;
  dataContract.contract.floor = contractSave.pisoDireccion;
  dataContract.contract.door = contractSave.puertaDireccion;
  dataContract.contract.postalCode = contractSave.codPostalDireccion;
  dataContract.contract.iban = contractSave.iban;
  dataContract.contract.entity = contractSave.entidad;
  dataContract.contract.office = contractSave.sucursal;
  dataContract.contract.dc = contractSave.dc;
  dataContract.contract.account = contractSave.cuenta;
  dataContract.contract.nameSigner = contractSave.nombreFirmante;
  dataContract.contract.surnameSigner = contractSave.apellidosFirmante;
  dataContract.contract.dniSigner = contractSave.dniFirmante;
  dataContract.contract.emailSigner = contractSave.movilFirmante;
  dataContract.contract.phoneSigner = contractSave.mailFirmante;
  return dataContract;
}

function parseEnterMargins(response: ContractDraft): EnterMargins {
  let enterMargins: EnterMargins;
  if (response.infoAnalisis.indicadorMargen === 1) {
    enterMargins = {
      marginTP: parseMarginBack(response.infoAnalisis.enterMargins.marginTP),
      marginsTE: {
        p1: parseMarginBack(response.infoAnalisis.enterMargins.marginsTE?.p1),
        p2: parseMarginBack(response.infoAnalisis.enterMargins.marginsTE?.p2),
        p3: parseMarginBack(response.infoAnalisis.enterMargins.marginsTE?.p3),
        p4: parseMarginBack(response.infoAnalisis.enterMargins.marginsTE?.p4),
        p5: parseMarginBack(response.infoAnalisis.enterMargins.marginsTE?.p5),
        p6: parseMarginBack(response.infoAnalisis.enterMargins.marginsTE?.p6)
      }
    };
  } else {
    enterMargins = {
      marginTP: response.infoAnalisis.enterMargins.marginTP?.toString(),
      marginsTE: {
        p1: response.infoAnalisis.enterMargins.marginsTE?.p1.toString(),
        p2: response.infoAnalisis.enterMargins.marginsTE?.p2.toString(),
        p3: response.infoAnalisis.enterMargins.marginsTE?.p3.toString(),
        p4: response.infoAnalisis.enterMargins.marginsTE?.p4.toString(),
        p5: response.infoAnalisis.enterMargins.marginsTE?.p5.toString(),
        p6: response.infoAnalisis.enterMargins.marginsTE?.p6.toString()
      }
    };
  }
  return enterMargins;
}

function parseMargin(margin: string): number {
  if (parseFloat(margin) >= 0) {
    return parseFloat(margin.toString().replace(',', '.'));
  }
  return null;
}

function parseMarginBack(margin: number): string {
  if (typeof (margin) === 'number') {
    return margin.toString().replace('.', ',');
  }
  return null;
}
